export const LEFT = 'left';
export const CENTER = 'center';
export const RIGHT = 'right';
export const FULL = 'full';

export const NONE_TYPE = 'none';
export const BANNER_TYPE = 'banner';
export const LOGO_TYPE = 'logo';
export const ALT_TEXT_LABEL = 'Alt Text';

export const SMALL = 'small';
export const MEDIUM = 'medium';
export const LARGE = 'large';
export const X_LARGE = 'x-large';

export const DISPLAY_MODE_STANDARD = 'thin';
export const DISPLAY_MODE_PANEL = 'panel';
export const PANEL_DISPLAY_RIGHT = 'split-right';
export const PANEL_DISPLAY_LEFT = 'split-left';
export const DISPLAY_MODE_FULL_SCREEN = 'full-screen';
export const DISPLAY_MODE_FORM_INLINE = 'inline';

export const DEFAULT_FORM_WIDTH = '30rem';
export const FULL_WIDTH_FORM = '100vw';

export const DEFAULT_FORM_STANDARD_WIDTH = '31.25rem';

export const DISPLAY_MODE_WIDTH = {
    [DISPLAY_MODE_STANDARD]: DEFAULT_FORM_STANDARD_WIDTH,
    [DISPLAY_MODE_PANEL]: DEFAULT_FORM_STANDARD_WIDTH,
    [DISPLAY_MODE_FULL_SCREEN]: '100%',
    [DISPLAY_MODE_FORM_INLINE]: '100%',
};

export const FORM_CONTENT_WIDTH = {
    [DISPLAY_MODE_STANDARD]: DEFAULT_FORM_STANDARD_WIDTH,
    [DISPLAY_MODE_PANEL]: DEFAULT_FORM_STANDARD_WIDTH,
    [DISPLAY_MODE_FULL_SCREEN]: DEFAULT_FORM_STANDARD_WIDTH,
    [DISPLAY_MODE_FORM_INLINE]: '100%',
};

export const BASE_MOBILE_FONT_SIZE = 16;

export const DROPDOWN_INPUT_TYPE = 'dropdown';
export const TEXT_INPUT_TYPE = 'textInput';

export const SPACING_TIGHT = 'tight';
export const SPACING_STANDARD = 'standard';
export const SPACING_LOOSE = 'loose';
export const SPACING_CUSTOM = 'custom';
export const SPACING_DATA_MODE = 'mode';
export const SPACING_DATA_NODES_SEPARATION = 'question';
export const SPACING_DATA_LABEL_SEPARATION = 'label';

export const DEFAULT_FORM_PADDING = '3.125rem';
